module.exports = __webpack_public_path__ + "img/行业培训默认封面图.7f12080a.png";